// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Sa69","selected":"Chip_selected__1Q55X"};